export default __webpack_public_path__ + "static/dashboardUI-31a3fe6d2e8a4de6d5956b5ebb9f34ea.png";